import { render, staticRenderFns } from "./Relaxation_pod.vue?vue&type=template&id=ee027ce8"
import script from "./Relaxation_pod.vue?vue&type=script&lang=js"
export * from "./Relaxation_pod.vue?vue&type=script&lang=js"
import style0 from "./Relaxation_pod.vue?vue&type=style&index=0&id=ee027ce8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports